module.exports = __webpack_public_path__ + "img/wechat-icon.ea058726.png";